import React, { useState, useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import MUIDataTable from "mui-datatables";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import IconButton from "@material-ui/core/IconButton";
import Popup from "../../../components/Controls/Popup";
import Notification from "../../../components/SnackBar/Notification";
import { makeStyles, Tooltip } from "@material-ui/core";
import {RMPriceForm} from "./RMPriceForm";
import { ThemeProvider } from '@mui/material/styles';
import CustomTheme from "../../../components/CustomTheme/CustomTheme";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(3),
  },
  iconButtonColor: {
    color: "#fff",
    "&:hover": {
      color: "#0000ff",
    },
  },
}));

export default function RMPrice() {
  const classes = useStyles();
  const [RMPriceList, setRMPriceList] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [rmPriceRecord, setRMPriceRecord] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);

  var userType = localStorage.getItem('user_type');


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const AxiosHeader = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("access_token")}`
    },
  }

  async function fetchRMPrice() {

    try {
      await axios
        .get("/api/rent-machine-price-list/", AxiosHeader)
        .then((res) => {
          setRMPriceList(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  }

  const postRMPrice = async (values, setSubmitting) => {

    try {
      await axios
        .post("/api/rent-machine-price-create/", values, AxiosHeader)
        .then((resp) => {
          setRMPriceRecord(resp.data);
          setSubmitting(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const updateRMPrice = async (values, setSubmitting) => {

    try {
      await axios
        .put(`/api/rent-machine-price-update/${values.id}/`, values, AxiosHeader)
        .then((resp) => {
          setRMPriceRecord(resp.data);
          setSubmitting(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    fetchRMPrice();
  }, [rmPriceRecord]);

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "name",
      label: "Machine Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "price",
      label: "Price",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Actions",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          let item;
          tableMeta.tableData.forEach(function (rmPrice) {
            if (rmPrice.id == tableMeta.rowData[0])
              return (item = rmPrice);
          });
          return (
            <>
              <IconButton
                color="primary"
                onClick={() => {
                  openInPopup(item);
                }}
              >
                <EditIcon fontSize="medium" />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const addOrEdit = (rmPrice, resetForm, setSubmitting) => {
    if (rmPrice.id === 0) postRMPrice(rmPrice, setSubmitting);
    else updateRMPrice(rmPrice, setSubmitting);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setNotify({
      isOpen: true,
      message: "Submitted Successfully",
      type: "success",
    });
  };

  const options = {
    filterType: "dropdown",
    selectableRows: "none",
    responsive: "standard",
    rowsPerPage: [100],
    rowsPerPageOptions: [20, 50, 100, 200],
    customToolbar: () => {
      return (
        <Tooltip title={"Add New"}>
          <IconButton className={classes.iconButtonColor}
            onClick={() => {
              setOpenPopup(true);
              setRecordForEdit(null);
            }}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      );
    },
    print: false,
    download: false,
  };

  return (
    <ThemeProvider theme={CustomTheme()}>
    <div>
      <MUIDataTable
        title={"Rent Machine Price List"}
        data={RMPriceList}
        columns={columns}
        options={options}
        className={classes.pageContent}
      />
      <Popup
        title="Rent Machine Price Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <RMPriceForm recordForEdit={recordForEdit} addOrEdit={addOrEdit} RMPriceList={RMPriceList} />
      </Popup>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
    </ThemeProvider>
  );
}
